import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "o-hero__text-wrap" }
const _hoisted_4 = {
  key: 0,
  class: "o-hero__heading"
}
const _hoisted_5 = { class: "o-hero__heading--bold" }
const _hoisted_6 = {
  key: 1,
  class: "o-hero__heading"
}
const _hoisted_7 = { class: "o-hero__heading--bold" }
const _hoisted_8 = {
  key: 2,
  class: "o-hero__text"
}
const _hoisted_9 = {
  key: 0,
  width: "14",
  height: "19",
  viewBox: "0 0 14 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.14 4.92986L4.57 0.359863L0 4.92986L4.57 9.49986L0 14.0699L4.57 18.6399L9.14 14.0699L13.71 9.49986L9.14 4.92986Z",
  fill: "white"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 3,
  class: "a-btn a-btn--secondary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slide = _resolveComponent("slide")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_carousel = _resolveComponent("carousel")!

  return (_openBlock(), _createBlock(_component_carousel, {
    "items-to-show": 1,
    autoplay: _ctx.autoplay,
    "wrap-around": _ctx.infinite
  }, {
    addons: _withCtx(() => [
      _createVNode(_component_pagination)
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide) => {
        return (_openBlock(), _createBlock(_component_slide, { key: slide }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["o-hero__container", slide.fields.placement.value])
            }, [
              (slide.fields.link.value != null)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: slide.fields.link.value.href,
                    class: "o-hero__link"
                  }, null, 8, _hoisted_1))
                : _createCommentVNode("", true),
              _createElementVNode("img", {
                src: slide.fields.image.value.src,
                class: "o-hero__image"
              }, null, 8, _hoisted_2),
              (
            slide.fields.normalTopHeading.value != '' ||
            slide.fields.boldTopHeading.value != '' ||
            slide.fields.normalBottomHeading.value != '' ||
            slide.fields.boldBottomHeading.value != '' ||
            slide.fields.text.value != ''
          )
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["o-hero__overlay", slide.fields.boxColor.value])
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      (
                slide.fields.normalTopHeading.value != '' ||
                slide.fields.boldTopHeading.value != ''
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(slide.fields.boldTopHeading.value), 1),
                            _createTextVNode(" " + _toDisplayString(slide.fields.normalTopHeading.value), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (
                slide.fields.normalBottomHeading.value != '' ||
                slide.fields.boldBottomHeading.value != ''
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("span", _hoisted_7, _toDisplayString(slide.fields.boldBottomHeading.value), 1),
                            _createTextVNode(" " + _toDisplayString(slide.fields.normalBottomHeading.value), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (slide.fields.text.value != '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createTextVNode(_toDisplayString(slide.fields.text.value) + " ", 1),
                            (slide.fields.showArrow.value)
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (
                !slide.fields.showArrow.value && slide.fields.link.value != null
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(slide.fields.link.value.text), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["autoplay", "wrap-around"]))
}